import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';
import { FieldMeta } from '../common/FieldMeta';

export type NoteType = BaseField & {
  type: 'Note';
};

function NoteElement({ field, errors, isTouched }: StaticFieldProps<NoteType>) {
  return (
    <div>
      <FieldMeta field={field} errors={errors} isTouched={isTouched} />
    </div>
  );
}

const Descriptor: FieldDescriptor<NoteType> = {
  FieldComponent: NoteElement,
  name: 'Note',
};

export default Descriptor;
